<template>
    <resource-index title="Транзакции" :endpoint="endpoint">
        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Заказ</th>
                <th class="text-left p-3 px-5" scope="col" v-if="modelType == 'product'">Получатель</th>
                <th class="text-left p-3 px-5" scope="col">Стоимость</th>
                <th class="text-left p-3 px-5" scope="col">Сумма</th>
                <th class="text-left p-3 px-5" scope="col">Дата</th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:table-filters="slotProps">
            <tr class="border-b bg-gray-100">
                <th class="p-3 px-5" scope="col"></th>
                <th class="p-3 px-5" scope="col" v-if="modelType == 'product'"></th>
                <th class="p-3 px-5" scope="col"></th>
                <th class="p-3 px-5" scope="col"></th>
                <th class="p-3 px-5" scope="col">
                    <date-field
                        v-model="slotProps.filters.created_at"
                        format="Y-m-d"
                        mode="range"
                        :wrap="false"
                        displayFormat="d.m.Y"
                    />
                </th>
                <th class="p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            <td class="p-3 px-5">
                <span
                    class="badge whitespace-no-wrap badge-indigo"
                    v-if="slotProps.entry.order"
                >
                  <template v-if="slotProps.entry.order.product">
                    {{ slotProps.entry.order.product.unique_id }} - {{ slotProps.entry.order.product.name  }} (#{{ slotProps.entry.order.id }})
                  </template>
                  <template v-else>
                    Заказ #{{ slotProps.entry.order.id }}
                  </template>
                </span>
                <span
                    class="badge whitespace-no-wrap badge-danger"
                    v-else-if="slotProps.entry.amount < 0"
                >Снятие</span>
                <span class="badge whitespace-no-wrap badge-warning" v-else>–</span>
            </td>

            <td
                class="p-3 px-5"
                v-if="modelType == 'product'"
            >({{ recipientTypes[slotProps.entry.recipient_type] }}) {{ slotProps.entry.recipient.name ? slotProps.entry.recipient.name : (slotProps.entry.recipient.full_name ? slotProps.entry.recipient.full_name : '–') }}</td>

            <td class="p-3 px-5">
                <span
                    class="badge whitespace-no-wrap badge-success"
                    v-if="slotProps.entry.order"
                >{{ slotProps.entry.order.amount }} ₽</span>
                <span class="badge whitespace-no-wrap badge-warning" v-else>–</span>
            </td>

            <td class="p-3 px-5">
                <span class="badge whitespace-no-wrap badge-success">{{ slotProps.entry.amount }} ₽</span>
            </td>

            <td class="p-3 px-5">{{ localTime(slotProps.entry.created_at) }}</td>

            <td class="p-3 px-5">
                <router-link
                    class="btn btn-info"
                    :to="{ name: 'admin.billing.orders.edit', params: {id: slotProps.entry.order_id} }"
                    v-if="slotProps.entry.order"
                >Открыть</router-link>
            </td>
        </template>
    </resource-index>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    },

    props: {
        modelType: {
            type: String
        },
        modelId: {
            type: Number
        }
    },

    data() {
        return {
            recipientTypes: {
                account: "Счет",
                fund: "Фонд",
                user: "Пользователь"
            },
            endpoint: `/admin/billing/transactions/${this.modelType}/${this.modelId}`
        };
    },

    methods: {},

    mounted() {}
};
</script>
